import React, { useState } from 'react'
import { useCustomSearchParams } from '../../../../hooks/useCustomSearchParams';
import LongFormDialog from '../../../../components/Dialog/LongFormDialog';
import EnterSurveyForm from '../Header/EnterSurveyForm';
import Enterll55SurveyForm from '../../../LL55/components/SurveyResponse/EnterSurveyForm';
import { isSelfService } from '../../../../utils/helpers';

function ApartmentNumberColumns({ params ,ll55=false}) {
     const [anchorEl, setAnchorEl] = useState(false);
     const [refetch, setRefetch] = useCustomSearchParams("refetch");

     const role = JSON.parse(localStorage.getItem("userData")).role;
     const selfService = isSelfService();

     const handleClose = () => {
       setAnchorEl(false);
       setRefetch("refetch", refetch ? refetch + 1 : 1);
     };
     const handleClick = () => {
      (role === "admin" || selfService) && setAnchorEl(true);
     };
  return (
    <>
      {anchorEl && (
        <LongFormDialog
          open={anchorEl}
          handleClose={handleClose}
          title={"Survey Response"}
          btnTitle={"Confirm"}
        >
          {ll55 ? (
            <Enterll55SurveyForm
              onClose={handleClose}
              initialData={{
                dates: new Date(),
                survey_id: params.row.compliance?.survey_id,
              }}
            />
          ) : (
            <EnterSurveyForm
              onClose={handleClose}
              initialData={{
                dates: new Date(),
                survey_id: params.row.compliance?.survey_id,
              }}
            />
          )}
        </LongFormDialog>
      )}
      <p
        className={`unit-ticket ${
          role === "admin" || selfService ? "cursor-pointer" : ""
        } `}
        onClick={handleClick}
      >
        {params.value}
      </p>
    </>
  );
}

export default ApartmentNumberColumns